const pageNameKey = "machinesRequestRemoteMachineAccessDrawerModal";

export const machinesRequestRemoteMachineAccessDrawerModalEn = {
  [pageNameKey]: {
    STtitle: "Request Remote machine Access",
    OTtitle: "Incoming Remote machine Access Request",
    requestDetails: "Request Details",
    sessionLength: "Requested Session Length",
    sessionType: "Session Privacy",
    privateSession: "Private",
    publicSession: "Public",
    requestedSessionLength: "Requested Session Length",
    requestMessage: "Request Message (Optional)",
    requestMessagePlaceholder: "Why are you requesting remote access?",
    requestAccessButton: "Request Access",
    denyButton: "Deny",
    approveButton: "Approve",
    cancelButton: "Cancel Request",
    minutes: "Minutes",
    hours: "Hours",
    requestedBy: "Requested By",
    machine: "Machine",
    SourceIcon: "Source",
    userProfileIcon: "User Profile",
    iconBuilding: "Building",
    sessionTypeInfoPopoverAltText: "Session type info",
    privateSessionInfoPopoverText: "Only you can connect to this session",
    publicSessionInfoPopoverText:
      "Other Technicians and Operators can join this session as viewers.",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalPtBr = {
  [pageNameKey]: {
    STtitle: "Solicitar acesso remoto à máquina",
    OTtitle: "Solicitação de acesso remoto à máquina recebida",
    requestDetails: "Detalhes da solicitação",
    sessionLength: "Duração da sessão solicitada",
    sessionType: "Privacidade da sessão",
    privateSession: "Privada",
    publicSession: "Pública",
    requestedSessionLength: "Duração da sessão solicitada",
    requestMessage: "Mensagem da solicitação (opcional)",
    requestMessagePlaceholder: "Por que você está solicitando acesso remoto?",
    requestAccessButton: "Solicitar acesso",
    denyButton: "Negar",
    approveButton: "Aprovar",
    cancelButton: "Cancelar solicitação",
    minutes: "Minutos",
    hours: "Horas",
    requestedBy: "Solicitado por",
    machine: "Máquina",
    SourceIcon: "Fonte",
    userProfileIcon: "Perfil do usuário",
    iconBuilding: "Construção",
    sessionTypeInfoPopoverAltText: "Informações do tipo de sessão",
    privateSessionInfoPopoverText:
      "Somente você pode se conectar a esta sessão.",
    publicSessionInfoPopoverText:
      "Outros técnicos e operadores podem entrar nesta sessão como visualizadores.",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalDe = {
  [pageNameKey]: {
    STtitle: "Remote-Maschinenzugriff anfordern",
    OTtitle: "Eingehende Anforderung für Remote-Maschinenzugriff",
    requestDetails: "Anforderungsdetails",
    sessionLength: "Angeforderte Sitzungsdauer",
    sessionType: "Sitzungsdatenschutz",
    privateSession: "Privat",
    publicSession: "Öffentlich",
    requestMessage: "Anforderungsnachricht (Optional)",
    requestMessagePlaceholder: "Warum fordern Sie Fernzugriff an?",
    requestAccessButton: "Zugriff anfordern",
    approveButton: "Genehmigen",
    denyButton: "Ablehnen",
    cancelButton: "Anfrage abbrechen",
    minutes: "Minuten",
    hours: "Stunden",
    requestedSessionLength: "Angeforderte Sitzungsdauer",
    requestedBy: "Angefordert von",
    machine: "Maschine",
    SourceIcon: "Quelle",
    userProfileIcon: "Benutzerprofil",
    iconBuilding: "Gebäude",
    sessionTypeInfoPopoverAltText: "Informationen zum Sitzungstyp",
    privateSessionInfoPopoverText:
      "Nur Sie können sich mit dieser Sitzung verbinden.",
    publicSessionInfoPopoverText:
      "Andere Techniker und Bediener können dieser Sitzung als Zuschauer beitreten.",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalZhHans = {
  [pageNameKey]: {
    STtitle: "请求远程机器访问",
    OTtitle: "传入的远程机器访问请求",
    requestDetails: "请求详情",
    sessionLength: "请求的会话时长",
    sessionType: "会话隐私",
    privateSession: "私有",
    publicSession: "公共",
    requestMessage: "请求消息（可选）",
    requestMessagePlaceholder: "您为什么要请求远程访问？",
    requestAccessButton: "请求访问",
    approveButton: "批准",
    denyButton: "拒绝",
    cancelButton: "取消请求",
    minutes: "分钟",
    hours: "小时",
    requestedSessionLength: "请求的会话时长",
    requestedBy: "请求者",
    machine: "机器",
    SourceIcon: "来源",
    userProfileIcon: "用户资料",
    iconBuilding: "建筑",
    sessionTypeInfoPopoverAltText: "会话类型信息",
    privateSessionInfoPopoverText: "只有您可以连接到此会话。",
    publicSessionInfoPopoverText:
      "其他技术人员和操作员可以作为查看者加入此会话。",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalIt = {
  [pageNameKey]: {
    STtitle: "Richiedi accesso alla macchina remota",
    OTtitle: "Richiesta di accesso remoto alla macchina in entrata",
    requestDetails: "Dettagli della richiesta",
    sessionLength: "Durata sessione richiesta",
    sessionType: "Privacy della sessione",
    privateSession: "Privata",
    publicSession: "Pubblica",
    requestedSessionLength: "Durata sessione richiesta",
    requestMessage: "Messaggio di richiesta (facoltativo)",
    requestMessagePlaceholder: "Perché stai richiedendo l'accesso remoto?",
    requestAccessButton: "Richiedi accesso",
    denyButton: "Rifiuta",
    approveButton: "Approva",
    cancelButton: "Annulla richiesta",
    minutes: "Minuti",
    hours: "Ore",
    requestedBy: "Richiesto da",
    machine: "Macchina",
    SourceIcon: "Macchina",
    userProfileIcon: "Profilo utente",
    iconBuilding: "Edificio",
    sessionTypeInfoPopoverAltText: "Informazioni sul tipo di sessione",
    privateSessionInfoPopoverText:
      "Solo tu puoi connetterti a questa sessione.",
    publicSessionInfoPopoverText:
      "Altri tecnici e operatori possono partecipare a questa sessione come osservatori.",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalEs = {
  [pageNameKey]: {
    STtitle: "Solicitar acceso a máquina remota",
    OTtitle: "Solicitud entrante de acceso remoto al equipo",
    requestDetails: "Detalles de la solicitud",
    sessionLength: "Duración de sesión solicitada",
    sessionType: "Privacidad de la sesión",
    privateSession: "Privada",
    publicSession: "Pública",
    requestedSessionLength: "Duración de sesión solicitada",
    requestMessage: "Mensaje de solicitud (opcional)",
    requestMessagePlaceholder: "¿Por qué solicita acceso remoto?",
    requestAccessButton: "Solicitar acceso",
    denyButton: "Denegar",
    approveButton: "Aprobar",
    cancelButton: "Cancelar solicitud",
    minutes: "Minutos",
    hours: "Horas",
    requestedBy: "Solicitado por",
    machine: "máquina",
    SourceIcon: "Origen",
    userProfileIcon: "Perfil de usuario",
    iconBuilding: "Edificio",
    sessionTypeInfoPopoverAltText: "Información del tipo de sesión",
    privateSessionInfoPopoverText: "Solo usted puede conectarse a esta sesión.",
    publicSessionInfoPopoverText:
      "Otros técnicos y operadores pueden unirse a esta sesión como observadores.",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalNl = {
  [pageNameKey]: {
    OTtitle: "Inkomend verzoek om externe machinetoegang",
    STtitle: "Externe machinetoegang aanvragen",
    SourceIcon: "Bron",
    approveButton: "Goedkeuren",
    cancelButton: "Verzoek annuleren",
    denyButton: "Afwijzen",
    hours: "Uren",
    iconBuilding: "Gebouw",
    machine: "Machine",
    minutes: "Minuten",
    requestAccessButton: "Toegang aanvragen",
    requestDetails: "Verzoekdetails",
    requestMessage: "Verzoekbericht (optioneel)",
    requestMessagePlaceholder: "Waarom vraagt u externe toegang aan?",
    requestedBy: "Aangevraagd door",
    requestedSessionLength: "Aangevraagde sessieduur",
    sessionLength: "Aangevraagde sessieduur",
    sessionType: "Sessieprivacy",
    privateSession: "Privé",
    publicSession: "Openbaar",
    sessionTypeInfoPopoverAltText: "Informatie over sessietype",
    privateSessionInfoPopoverText:
      "Alleen u kunt verbinding maken met deze sessie.",
    publicSessionInfoPopoverText:
      "Andere technici en operators kunnen deelnemen aan deze sessie als kijker.",
    userProfileIcon: "Gebruikersprofiel",
  },
};

export const machinesRequestRemoteMachineAccessDrawerModalTr = {
  [pageNameKey]: {
    OTtitle: "Gelen Uzak Makine Erişim İsteği",
    STtitle: "Uzaktan Makine Erişimi Talebi",
    SourceIcon: "Kaynak",
    approveButton: "Onaylamak",
    cancelButton: "İsteği İptal Et",
    denyButton: "Reddetmek",
    hours: "Saat",
    iconBuilding: "Bina",
    machine: "Makine",
    minutes: "dakika",
    privateSession: "Özel",
    privateSessionInfoPopoverText: "Bu oturuma yalnızca siz bağlanabilirsiniz",
    publicSession: "Halk",
    publicSessionInfoPopoverText:
      "Diğer Teknisyenler ve Operatörler bu oturuma izleyici olarak katılabilir.",
    requestAccessButton: "Erişim Talebi",
    requestDetails: "Ayrıntıları Talep Et",
    requestMessage: "İstek Mesajı (İsteğe Bağlı)",
    requestMessagePlaceholder: "Neden uzaktan erişim istiyorsunuz?",
    requestedBy: "İsteyen",
    requestedSessionLength: "Talep Edilen Oturum Süresi",
    sessionLength: "Talep Edilen Oturum Süresi",
    sessionType: "Oturum Gizliliği",
    sessionTypeInfoPopoverAltText: "Oturum türü bilgisi",
    userProfileIcon: "Kullanıcı Profili",
  },
};
